























import { Vue, Component, Prop } from 'vue-property-decorator';
import VoteButton from '../components/VoteButtonNew.vue';

@Component({
  components: {
    VoteButton,
  },
})
export default class ListItem extends Vue {
  @Prop() data!: any;
  @Prop() index!: number;
  @Prop({ default: 0 }) maxvotelimit!: number;
  voteName: string = '2023project/q2/2023hlsqzdy_water';
  votSuccess(e: any) {
    this.data.votes = e;
  }
}
